export interface ReplayGateInput {
  enabled: boolean;
  environment: string;
  email: string;
  webdriver: boolean;
  pathname: string;
}

/**
 * Session replay only for real, authenticated prod users. Playwright and the
 * capture lambdas set `navigator.webdriver`; e2e accounts are `e2e+<id>@`.
 * Internal @cohesive.ai staff are recorded on purpose.
 */
export function shouldRecordReplay({
  enabled,
  environment,
  email,
  webdriver,
  pathname,
}: ReplayGateInput): boolean {
  return (
    enabled &&
    environment === "prod" &&
    !webdriver &&
    pathname !== "/canvas-capture.html" &&
    !email.startsWith("e2e+")
  );
}
